import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Button from "shared/components/FormElements/Button";

import "./RouteLimitBlocker.css";

/**
 * RouteLimitBlocker - Full blocker component shown when user tries to create a new route
 * but has reached their plan's route limit
 *
 * @param {Object} props
 * @param {Object} props.limitStatus - Route limit status { current, max, remaining }
 * @param {Function} props.onClose - Callback when user clicks close/back button
 * @param {boolean} props.isOverlay - If true, renders as overlay on top of form
 */
const RouteLimitBlocker = ({ limitStatus, onClose, isOverlay = false }) => {
  const { t } = useTranslation();

  const max = limitStatus?.max || 0;
  const vehicleRouteCount = limitStatus?.vehicleRouteCount || 0;
  const personelServiceCount = limitStatus?.personelServiceCount || 0;

  return (
    <div className={`route-limit-blocker ${isOverlay ? "route-limit-blocker--overlay" : ""}`}>
      <div className="route-limit-blocker__content">
        <div className="route-limit-blocker__icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <h2 className="route-limit-blocker__title">{t("routeLimitExceeded")}</h2>

        <div className="route-limit-blocker__message">
          <p>{t("routeLimitExceededLine1", { max })}</p>
          {vehicleRouteCount > 0 && (
            <p className="route-limit-blocker__breakdown">
              {t("studentRoutes")}: {vehicleRouteCount}
            </p>
          )}
          {personelServiceCount > 0 && (
            <p className="route-limit-blocker__breakdown">
              {t("employeeRoutes")}: {personelServiceCount}
            </p>
          )}
          <p className="route-limit-blocker__upgrade-text">{t("routeLimitExceededLine2")}</p>
        </div>

        <div className="route-limit-blocker__actions">
          <Link to="/settings?tab=subscription" className="route-limit-blocker__upgrade-btn">
            {t("upgradePlan")}
          </Link>
          {onClose && (
            <Button type="button" onClick={onClose} inverse>
              {t("close")}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default RouteLimitBlocker;
